import React from 'react';
import { Menu } from './menu';
import WhatsApp from './assets/whatsapp.png';
import Phone from './assets/phone.png';


function App() {
  return (
    <div className='App '>
      <Menu />
      <a href="tel:+919996212490">
        <img src={Phone} alt='Contact Us' width={36} height={36} className='callToAction' />
      </a>
      <a href={
        `https://api.whatsapp.com/send?phone=919996212490&text=${encodeURIComponent('Hi Shivay Durga Foods, \nI have a question about your menu and delivery options.')}`
      } target='_blank' rel="noreferrer" className='whatsApp'>
        <img src={WhatsApp} alt='Shivay Durga' width={36} height={36} />
      </a>
    </div>
  );
}

export default App;
